import React from "react";
import { Link } from "react-router-dom";
import "./featuresDropDownOption.css";

const FeaturesDropDownOption = ({ icon, title, details, pageLink, New }) => {
  return (
    <Link to={pageLink} className="featuresOption">
      <div className="featuresOption">
        <div className="featuresOption-icon">
          <img src={icon} alt="" />
        </div>
        <div className="featuresOption-content">
          <h5>
            {title}
            {New ? (
              <span className="featuresOption-content-newTag">New</span>
            ) : null}
          </h5>
          <p>{details}</p>
        </div>
      </div>
    </Link>
  );
};
export default FeaturesDropDownOption;
